import { Section } from '@/components/layout';
import { ResponsiveImage } from '@/components/media';
import { Reveal } from '@/components/motion';
import { GoldLine } from '@/components/ornaments';
import { Eyebrow } from '@/components/typography';
import styles from './InvitadasBuenosAires.module.css';

/**
 * INVITADAS ESPECIALES — encargo del cliente por WhatsApp (20-oct-2026): «la foto de
 * estas dos personas ponlas en el mismo lugar que esta, pero en Buenos Aires», con la
 * captura de la invitada de Bogotá. Mismo sitio (entre la reserva y la fila de
 * beneficios) y mismo gesto que `InvitadosBogota`: antetítulo dorado, filete y foto
 * con nombre. El filete es el de esta página (`GoldLine`), no el corazón de Bogotá.
 *
 * El texto es SOLO lo que trae la foto: sus nombres. Nada de biografía.
 */
export function InvitadasBuenosAires() {
  return (
    <Section background="surface" spacing="tight" width="default">
      <Reveal>
        <article className={styles.columna} aria-labelledby="ba-invitadas">
          <Eyebrow ink="gold" align="center">
            <span id="ba-invitadas">Invitadas especiales</span>
          </Eyebrow>
          <GoldLine ornament="diamond" width="sm" />
          <ResponsiveImage
            asset="buenos-aires/sil-romero-pato-brusa"
            sizes="(min-width: 48rem) 20rem, 80vw"
            className={styles.foto}
          />
          <h2 className={styles.nombre}>Sil Romero y Pato Brusa</h2>
        </article>
      </Reveal>
    </Section>
  );
}
